<template>
  <div v-loading="loading">
    <!--    <q-card>-->
    <!--      <q-card-section  >-->
    <!--        <q-banner dense inline-actions class="text-white bg-blue-7" v-for="(label,tripid) in tripsToHandle" >-->
    <!--          <span>{{ label }}</span>-->
    <!--          <template v-slot:action>-->
    <!--            <q-btn color="bg-blue-6" label="Change it" @click="selectedTrip={id:tripid}"-->
    <!--                   style="padding-left: 3px;padding-right: 3px"/>-->
    <!--          </template>-->
    <!--        </q-banner>-->
    <!--      </q-card-section>-->

    <!--    </q-card>-->
    <q-card>
      <el-collapse-transition>
        <q-card-section v-if="!selectedTrip">
          <q-banner dense inline-actions class="text-white bg-blue-7" v-for="(label,tripid) in tripsToHandle">
            <span>{{ label }}</span>
            <template v-slot:action>
              <q-btn color="bg-blue-6" label="Change it" @click="selectedTrip={id:tripid}"
                     style="padding-left: 3px;padding-right: 3px"/>
            </template>
          </q-banner>
        </q-card-section>
      </el-collapse-transition>
      <el-collapse-transition>
        <q-card-section v-if="selectedTrip">
          <schedule-trip-form v-model="selectedTrip" v-if="selectedTrip" :minimal="true"
                              @done="selectedTrip=null;pivotData()"></schedule-trip-form>
        </q-card-section>
      </el-collapse-transition>
    </q-card>
    <q-card v-if="!isEmptyObject(missingPups)">
      <q-card-section>
        <div class="text-h6">There are some places that i cant recognise them</div>
      </q-card-section>

      <q-card-section>
        <q-banner dense inline-actions class="text-white bg-red" v-for="(lostPup,kidx) in missingPups" :key="kidx">
          <span>{{ lostPup.ppname }}</span><span v-if="lostPup.resort"
                                                 style="padding-left: 10px">At {{ lostPup.resort }}</span>
          <template v-slot:action>
            <q-btn color="red" label="Fix it" @click="processPup=lostPup" style="padding-left: 3px;padding-right: 3px"/>
          </template>
        </q-banner>
      </q-card-section>
    </q-card>
    <!--    <pre>{{treeData}}</pre>-->
    <q-card v-show="!processPup&&!selectedTrip">
      <q-card-section>
        <el-tree :data="treeData" :props="treeProps" v-if="treeData?.length" :default-expand-all="expandAll">
          <template slot-scope="{ node, data }">
            <el-row v-if="!node.isLeaf" type="flex" justify="space-between" style="width: 100%">
              <el-col v-html="data.propertyName" :span="8"></el-col>
              <el-col v-for="(v,idx) in aggrData(data._childrenData||data.childrenData)" :key="idx" :span="4">
                <label>{{ v.label }}:</label><span>{{ v.sum }}</span>
              </el-col>
            </el-row>
            <el-row v-else>
              <h4 v-if="!displayData">{{ data?.msg }}</h4>
              <!--          <pre>{{data.values}}</pre>-->
              <s-table v-else :col-definitions="colDefinitions" v-model="data.values" :simple-lazy-loader="true"
                       :height-wish="false"></s-table>
            </el-row>

          </template>
        </el-tree>
      </q-card-section>
    </q-card>
    <div v-if="processPup">
      <s-pupresolver

          :forFileId="$route.params.fileid"
          :pupInfo="processPup"
          @done="removeLostPup"></s-pupresolver>
    </div>

  </div>
</template>

<script>
import {apiGetCall} from "../../api/laravel";
import * as api from "~/api/resource";

function groupByProperties(data, properties) {
  if (!properties.length) {
    return data;
  }

  const [firstProp, ...restProps] = properties;

  const groupedData = data.reduce((acc, item) => {
    const key = item[firstProp];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  for (const key in groupedData) {
    groupedData[key] = groupByProperties(groupedData[key], restProps);
  }

  return groupedData;
}

function transformObjectToNestedArray(obj) {
  function recurse(currentObj) {
    return Object.entries(currentObj).map(([key, value]) => {
      if (Array.isArray(value)) {
        _log_("TreeReporter theData..1 ", value);
        return {
          propertyName: key,
          childrenData: [{msg: 'Count bookings:' + value?.length, values: value.map(e => e._original)}],
          isLeaf: true,
          _childrenData: value
        };
      } else if (typeof value === 'object' && value !== null) {
        _log_("TreeReporter theData..2 ", value);
        return {
          propertyName: key,
          childrenData: recurse(value)
        };
      } else {
        _log_("TreeReporter theData..3 ", value);
        return {
          propertyName: key,
          childrenData: [value]
        };
      }
    });
  }

  return recurse(obj);
}

function sumNestedData(data, propertyNames) {
  const sums = propertyNames.reduce((acc, propName) => {
    acc[propName] = 0;
    return acc;
  }, {});

  function recurse(items) {
    items.forEach(item => {
      propertyNames.forEach(propName => {


        if (item.hasOwnProperty(propName)) {
          let sumVal = 0
          if (item?._original[propName] !== undefined && item?._original[propName] !== null)
            sumVal = item._original[propName] || 0
          else
            sumVal = item[propName] || 0
          // _log_('TreeReporter sums', `[${propName}] ${item[propName]}`,sumVal, item);
          sums[propName] += sumVal;
        }
      });

      const argData = item._childrenData || item.childrenData;
      if (Array.isArray(argData)) {
        recurse(argData);
      }
    });
  }

  recurse(data);

  return propertyNames.map(propName => ({
    prpName: propName,
    sum: sums[propName]
  }));
}


export default {
  name: "TreeReporter",

  props: {
    displayData: {
      type: Boolean,
      default: false
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    modxProcessor: {
      type: String,
      default: null
    },
    laraProcessor: {
      type: String,
      default: null
    },
    rQuery: {
      type: Object,
      default: () => {
      }
    },
    rowKeyField: {type: String, default: "id"},

    value: {
      type: Array,
      default: () => []
    },
    pivotCols: {
      type: Array,
      default: () => []
    },
    aggrCols: {
      type: Array,
      default: () => []
    },
    colDefinitions: {
      type: Array,
      default: () => []
    },
    defaultSort: {
      type: String,
      default: null
    },

  },
  data: function () {
    return {
      treeProps: {
        children: 'childrenData',
        label: 'propertyName'
      },
      selectedTrip: null,
      processPup: null,
      missingPups: {},
      tripsToHandle: {},
      loading: true,
      clock: 0,
      treeData: [],
      tableData: [],

    };
  },

  watch: {
    rQuery: {
      handler: async function () {
        this.pivotData()
      },
      deep: true
    },
    value: {
      handler: function (newValue) {
        // _log_("v-model,", newValue);
        if (!this.silent) {
          let newValueInexed = {}, changeFound = false
          newValue.forEach(c => newValueInexed[c[this.rowKeyField]] = c)
          let this_tableData = JSON.parse(JSON.stringify(this.tableData))
          this_tableData = this_tableData.map(r => {
            if (!newValueInexed[r[this.rowKeyField]]) return r
            const nr = {...r, ...(newValueInexed[r[this.rowKeyField]] || {})}
            changeFound = JSON.stringify(r) != JSON.stringify(nr)
            return changeFound ? nr : r
          })
          if (changeFound)
            this.tableData = this_tableData;
        }
      },
      deep: true
    },

  },
  computed: {
    indexedCols() {
      let iC = {}
      this.colDefinitions.forEach(c => iC[c.prop] = c)
      return iC
    },
    apiProcessor() {
      return this.modxProcessor || this.laraProcessor
    },
    filteredPivotCols() {
      return this.colDefinitions.filter(col => this.pivotCols.includes(col.prop))
    },
    filteredArgCols() {
      return this.colDefinitions.filter(col => this.aggrCols.includes(col.prop))
    }
  },
  async mounted() {

    this.pivotData()
    this.loading = false;

    // this.lazyLoadScroll();
  },

  methods: {
    removeLostPup(pupInfo) {
      delete this.missingPups[pupInfo.ppname + '.' + pupInfo.resort]
      this.processPup = null
    },
    aggrData(theData) {

      // theData = _.isArray(theData) ? {childrenData: theData} : theData;
      if (!theData?.length)
        return
      const o = sumNestedData(theData, this.aggrCols).map(r => {
        r.label = this.indexedCols[r.prpName]?.label || r.prpName;
        return r
      })
      // _log_("TreeReporter checking..aggrData ", o);
      return o;
    },
    async getServData(params = {}) {
      this.loading = true
      this.selectedTrip=null
      // _log_("checking..getServData ", params, this.query, this.controlQueryParams);
      if (this.apiProcessor) {
        const {data} = this.modxProcessor ? await api.fetchProcessor(this.apiProcessor, {
              ...this.rQuery,

              ...params,
              limit: 0,
              start: 0
            }) :
            await apiGetCall(this.apiProcessor, {
              ...this.rQuery,

              ...params,
              limit: 0,
              start: 0
            });
        this.$emit('data-loaded', data)
        this.loading = false
        return data;
      } else if (typeof this.endPoint === "function") {
        const data = await this.endPoint(params);
        if (data.data) return {results: data.data};
        else {
          this.loading = false
          return {results: data};
        }
      } else {
        this.loading = false
        return {data: {results: []}};
      }
    },
    async pivotData() {
      const data = await this.getServData()

      this.missingPups = {}
      this.tripsToHandle = {}
      this.processPup = null
      this.tableData = (data?.results || []).map(r => {
        let vRow = {}
        vRow._original = r
        vRow.interactions = {}
        this.colDefinitions.forEach(c => {
          vRow[c.prop] = this.displayVal(r[c.prop], c, r) || ('??' + c.prop)
          if (c.interact) vRow.interactions[c.prop] = this.displayVal(r[c.prop], c, r) || ('??' + c.prop)
        })
        if (!r.ppid) {
          this.missingPups[r.possible_pp.ppname + '.' + r.possible_pp.resort] = r.possible_pp


        }
        this.tripsToHandle[r.tripid] = this.formatDate(r.tripDateTime) + ':' + r.tripTitle
        return vRow
      })

      // _log_("TreeReporter checking..getServData ", this.tableData, this.rQuery);
      const gD = groupByProperties(this.tableData, this.pivotCols)

      // _log_('TreeReporter pivotData', gD)
      this.treeData = transformObjectToNestedArray(gD);
      _log_('TreeReporter pivotData 2', this.treeData)
      // _log_('TreeReporter pivotData 3', sumNestedData(this.treeData, this.aggrCols))
//       let pivotData=[]
//       this.tableData.forEach(row => {
//         this.filteredPivotCols.forEach(pivotCol => {
// const pivotVal=row[pivotCol.prop]
//           let pivotRow=
//         })
//       })
    }
  }
}

</script>
<style>
</style>
